export default {
  线索商户: "Doanh nghiệp đầu mối",
  商户ID: "Mã doanh nghiệp",
  入驻邮箱: "Email đăng ký",
  联系电话: "Số điện thoại",
  授权店铺: "Cửa hàng đã ủy quyền",
  报名商品数: "Số SP đã đăng ký",
  TAP合作店铺: "Cửa hàng hợp tác TAP",
  TAP合作商品数: "SP hợp tác TAP",
  TAP申样数: "Yêu cầu mẫu TAP",
  来源: "Nguồn",
  跟进: "Theo dõi",
  自主入驻: "Tự đăng ký",
  跟进商户: "Theo dõi nhà bán ",
  跟进人: "Người theo dõi",
  供应链名称: "Tên chuỗi cung ứng",
  "该店铺已绑定其他供应链，不可重复绑定！": "Cửa hàng này đã liên kết với chuỗi cung ứng khác, không thể liên kết lại!",
  供应链ID: "Mã chuỗi cung ứng",
  跟进联系方式: "Thông tin liên hệ",
  联系邮箱: "Email",
  "Youpik Grow联系电话": "SĐT Youpik Grow",
  店铺名称: "Tên cửa hàng",
  店铺号: "Mã cửa hàng",
  是: "Có",
  否: "Không",
  店铺商品数: "Số sản phẩm trong shop",
  店铺GMV: "GMV cửa hàng",
  店铺销量: "Doanh số cửa hàng",
  店铺总订单: "Tổng đơn hàng",
  SKU订单: "Đơn hàng theo SKU",
  订单均价: "Giá trị TB đơn hàng",
  "该店铺已授权至供应链，不可操作更改！": "Cửa hàng này đã liên kết với chuỗi cung ứng khác, không thể liên kết lại!",
  入驻状态: "Trạng thái đăng ký",
  未入驻: "Chưa đăng ký",
  已入驻: "Đã đăng ký",
  复制入驻链接: "Sao chép link mời",
  该商户已入驻: "Nhà bán đã đăng ký",
  "Youpik Grow账号详情": "Chi tiết tài khoản",
  查看: "Xem",
  入驻时间: "Thời gian đăng ký",
  申样等待处理: "Mẫu chờ xử lý",
  未处理样品申请: "Yêu cầu mẫu chưa xử lý",
  超过24hr未处理: "Yêu cầu mẫu chưa xử lý",
  最后一次申样日期: "Yêu cầu mẫu cuối cùng",
  发货链接: "Link giao hàng",
  跟进时间: "Ghi chú",
  查看发货详情: "Xem chi tiết giao hàng",
  复制发货链接: "Sao chép link giao hàng",
  编辑: "Chỉnh sửa",
  商家TAP活动配置: "Cấu hình chiến dịch TAP của nhà bán",
  活动ID: "ID chiến dịch",
  活动名称: "Tên chiến dịch",
  活动状态: "Trạng thái chiến dịch",
  进行中: "Đang diễn ra",
  邀约中: "Đang mời",
  待邀约: "Chờ mời",
  不可邀约: "Không thể mời",
  已结束: "Đã kết thúc",
  报名时间: "Thời gian đăng ký",
  活动时间: "Thời gian diễn ra",
  邀约状态: "Trạng thái mời",
  "进行中的联盟营销活动会在Youpik Grow公开展示给所有商家。": "Chiến dịch đang diễn ra sẽ được hiển thị công khai trên Youpik Grow cho tất cả nhà bán.",
  "活动进行中，还未展示给商家。": "Chiến dịch đang tiến hành, chưa hiển thị cho nhà bán",
  "活动结束，无法展示给商家": "Chiến dịch đã kết thúc",
  佣金要求: "Yêu cầu hoa hồng",
  公开佣金: "Hoa hồng công khai",
  Youpik佣金: "Hoa hồng Youpik",
  达人附加佣金: "Hoa hồng thêm cho creator",
  "商家在TikTok公开给达人的佣金%": "Phần trăm hoa hồng nhà bán công khai cho creator trên TikTok",
  "与Youpik合作，商家支付给Youpik的营销佣金。": "Hợp tác với Youpik, nhà bán sẽ trả hoa hồng tiếp thị cho Youpik.",
  "在公开佣金之上，商家需支付给达人的额外佣金加成%": "Trên hoa hồng công khai, bạn phải trả thêm cho creator %",
  寄样要求: "Yêu cầu gửi mẫu",
  必须: "Bắt buộc",
  非必须: "Không bắt buộc",
  编辑要求: "Chỉnh sửa yêu cầu",
  暂停邀约: "Tạm dừng mời",
  "在Youpik Grow商家后台暂停邀约该活动": "Tạm ngưng hiển thị chiến dịch trên Youpik Grow",
  "Youpik Grow商家后台将不再展示该活动，你还要继续吗？": "<span style='color: red'>Youpik Chiến dịch này sẽ không còn hiển thị trong Youpik Grow</span>，. Bạn có muốn tiếp tục không?",
  请设置该活动报名需满足的要求: "Vui lòng thiết lập yêu cầu tham gia",
  加入邀约: "Thêm vào lời mời",
  注册来源: "Nguồn đăng ký",
  注册邮箱: "Email đăng ký",
  是否合作TAP: "Có hợp tác TAP không",
  全部: "Tất cả",
  待发布: "Chờ phát hành",
  即将开始: "Sắp bắt đầu",
  "仅商家运营可操作！": "Chỉ người vận hành tài khoản mới có thể thao tác!",
  佣金范围错误: "Phạm vi hoa hồng không hợp lệ",
  商家BD邀请: "Tham gia từ BD",
  "复制成功，请勿将链接发送给错误商家！": "Copy thành công, vui lòng không gửi link đến nhà bán sai!"
};
